import { nextTick, type Ref } from 'vue'

export function useScrollToFirstError(containerRef?: Ref<HTMLElement | null>) {
  return (ctx: { errors: Record<string, unknown> }) => {
    if (!Object.keys(ctx.errors).length) return;

    nextTick(() => {
      const el = containerRef?.value?.querySelector('[has-error="true"]') as HTMLElement | null;
      console.log(el);
      if (el instanceof HTMLElement) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus();
      }
    });
  };
}
